import { alpha } from '@mui/material/styles';

import type { Theme } from '@mui/material/styles';

export const styles = (theme: Theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    minHeight: '250px',
    backgroundColor: theme.palette?.background?.paper,
    border: 'dashed',
    borderColor: theme.palette?.divider,
    borderRadius: theme.shape?.borderRadius,
    boxSizing: 'border-box',
    cursor: 'pointer',
    overflow: 'hidden',
    display: 'flex',
    transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
      borderColor: theme.palette.primary.main,
    },
  },
  active: {
    backgroundColor: alpha(theme.palette.success.main, 0.08),
    borderStyle: 'dashed',
    borderWidth: 3,
    borderColor: theme.palette.success.main,
  },
  invalid: {
    backgroundColor: alpha(theme.palette.error.main, 0.08),
    borderStyle: 'dashed',
    borderWidth: 3,
    borderColor: theme.palette.error.main,
  },
  disabled: {
    backgroundColor: theme.palette.action.disabledBackground,
    borderColor: theme.palette.action.disabled,
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: theme.palette.action.disabledBackground,
      borderColor: theme.palette.action.disabled,
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  text: {
    marginBottom: theme.spacing?.(3),
    marginTop: theme.spacing?.(3),
  },
  icon: {
    width: 51,
    height: 51,
    color: theme.palette?.text?.primary,
  },
});
